<template>
  <div class="page-container">
    <el-card style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input 
            v-model="searchKeyword" 
            placeholder="搜索分类名称" 
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus">新增分类</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <el-table :data="filteredData" border v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="分类名称" width="150"></el-table-column>
        <el-table-column prop="description" label="描述" width="250"></el-table-column>
        <el-table-column prop="sort" label="排序" width="100"></el-table-column>
        <el-table-column label="状态" width="150" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用"
              @change="handleStatusChange(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="分类名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CategoryManage',
  data() {
    return {
      tableData: [],
      loading: false,
      searchKeyword: '',
      dialogVisible: false,
      dialogTitle: '',
      form: {}
    }
  },
  computed: {
    filteredData() {
      if (!this.searchKeyword) {
        return this.tableData
      }
      return this.tableData.filter(item => 
        item.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
      )
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await this.$axios.get('/admin/category/list')
        if (res.data.code === 200) {
          // 确保每个分类都有 status 字段，默认为 1（启用）
          this.tableData = (res.data.data || []).map(item => ({
            ...item,
            status: item.status !== undefined ? item.status : 1
          }))
        }
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      // 搜索功能由computed处理
    },
    handleReset() {
      this.searchKeyword = ''
    },
    handleAdd() {
      this.dialogTitle = '新增分类'
      this.form = {
        name: '',
        description: '',
        sort: 0,
        status: 1
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑分类'
      this.form = { ...row }
      this.dialogVisible = true
    },
    async handleSave() {
      try {
        if (this.form.id) {
          await this.$axios.put(`/admin/category/${this.form.id}`, this.form)
        } else {
          await this.$axios.post('/admin/category', this.form)
        }
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.loadData()
      } catch (error) {
        this.$message.error('保存失败')
      }
    },
    handleDelete(row) {
      this.$confirm('确定删除该分类?', '提示', {
        type: 'warning'
      }).then(async () => {
        await this.$axios.delete(`/admin/category/${row.id}`)
        this.$message.success('删除成功')
        this.loadData()
      })
    },
    async handleStatusChange(row) {
      try {
        // 只更新 status 字段，避免其他字段被覆盖
        await this.$axios.put(`/admin/category/${row.id}`, {
          id: row.id,
          name: row.name,
          description: row.description,
          icon: row.icon,
          sort: row.sort,
          status: row.status
        })
        this.$message.success('状态更新成功')
        // 更新成功后重新加载数据，确保显示最新状态
        await this.loadData()
      } catch (error) {
        console.error('状态更新失败:', error)
        // 失败时重新加载数据，恢复为数据库中的值
        await this.loadData()
        this.$message.error('状态更新失败')
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
  background: transparent;
  min-height: calc(100vh - 60px);
}
</style>
